module.exports = __webpack_public_path__ + "static/img/zyuan.08824020.png";